module.exports = __webpack_public_path__ + "static/G1N3-68ee447ad1afaf31fbf4950faaa3b934.jpg";